module.exports = __webpack_public_path__ + "static/metal-frame07-d0dd75eedb46765b3e2055d91b630dfc.jpg";